import React, { useState, useRef,useEffect } from "react";
import './classes/EditAmbassador.css';
import Editor from "react-simple-wysiwyg";
import { configData } from "../config";
import { Link, useNavigate,useLocation  } from 'react-router-dom';

const EditAmbassadorProfile = ({uid,userLoggedInRoles, userSocailMediaAssets,picture,userAmbassadorAssets,userCommonAssets}) => {
 //console.log(userAmbassadorAssets.field_show_on_frontend_ambassado);
  const [formData, setFormData] = useState({
    field_biography: userCommonAssets.field_biography,
    field_sports_focus: [],
    field_show_on_frontend_ambassado:0,
    field_ambassador_slug:'',
    picture: null,
    pictureDelete: false,
    uid:uid,
    field_education: userCommonAssets.field_education,
    field_q_a: userCommonAssets.field_q_a, 
    social: {
      field_instagram_url: userSocailMediaAssets.field_instagram_url,
      field_instagram_handle: userSocailMediaAssets.field_instagram_handle,
      field_facebook_url: userSocailMediaAssets.field_facebook_url,
      field_facebook_handle: userSocailMediaAssets.field_facebook_handle,
      field_twitter_url: userSocailMediaAssets.field_twitter_url,
      field_user_youtube_url: userSocailMediaAssets.field_user_youtube_url,
      // field_linkedin_url: userSocailMediaAssets.field_linkedin_url,
      field_linkedin_url: userSocailMediaAssets.field_linkedin_url || '',
      field_linkedin_handle: userSocailMediaAssets.field_linkedin_handle,
    },
    field_how_to_contact_client: userCommonAssets.field_how_to_contact_client,	
  });

  const [formErrors, setFormErrors] = useState({});
  const [showSocialmediafields, setSocialmediafields] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("/basic/web/images/notavailable.jpg");
  const [showOnFrontend, setShowOnFrontend] = useState(true);
  const [buttonText, setButtonText] = useState('Save changes');
  const [errors, setErrors] = useState([]);

  const [toggles, setToggles] = useState({
              ambassadordetails:true,
              ambassadorbio:true,
              ambassadoreducation:true,
              ambassadorqa:true,
              ambassadorsocialmedia:true,
              ambassadorhowtocontact:true,              
            });
             const handleToggle = (key) => {
            setToggles((prev) => ({
                ...prev,
                [key]: !prev[key],
            }));
        };

    const navigate = useNavigate();
     const app_url = configData.APP_URL;
        const[success,setSuccess] = useState({});
  const [editorMode, setEditorMode] = useState({
    biography: true,
    education: true,
    qa: true,
    contact: true,
  });
  const [showDeletePictureCheckbox, setShowDeletePictureCheckbox] = useState(false);

  const fileInputRef = useRef();
    const toggleEditor = (field) => {
  setEditorMode((prev) => ({
    ...prev,
    [field]: !prev[field], 
  }));
};

const cleanHtmlOutput = (html) => {
  if (!html) return "";

  // Remove empty p/div/h1-h6 that only contain <br> or spaces
  let cleaned = html.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|&nbsp;|\s)*<\/\1\s*>/gi, "");

  // Remove stray <br>
  cleaned = cleaned.replace(/<br\s*\/?>/gi, "");

  // Check if anything meaningful is left
  const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, "").trim();

  return textOnly.length === 0 ? "" : cleaned.trim();
};
const onEditorChange = (field, value) => {
  const cleanedValue = cleanHtmlOutput(value);
  setFormData(prev => ({ ...prev, [field]: cleanedValue }));
};


  const toggleSocialmediafields = () => {
    setSocialmediafields(prev => !prev);
  };

  const sportsOptions = [
    { value: '_none', label: '- None -' },
    { value: 'all_sports', label: 'All Sports' },
    { value: 'action_sports', label: 'Action Sports' },
    { value: 'baseball', label: 'Baseball' },
    { value: 'basketball', label: 'Basketball' },
    { value: 'boxing', label: 'Boxing' },
    { value: 'cricket', label: 'Cricket' },
    { value: 'football', label: 'Football (American)' },
    { value: 'golf', label: 'Golf' },
    { value: 'hockey', label: 'Hockey' },
    { value: 'martial_arts', label: 'Martial Arts' },
    { value: 'motor_sports', label: 'Motor Sports' },
    { value: 'nil', label: 'NIL' },
    { value: 'olympic_sports', label: 'Olympic' },
    { value: 'rugby', label: 'Rugby' },
    { value: 'soccer', label: 'Soccer' },
    { value: 'volleyball', label: 'Volleyball' },
    { value: 'weightlifting', label: 'Weightlifting' },
  ];
  
useEffect(() => {
  
  if (userAmbassadorAssets.length > 0) {
    userAmbassadorAssets.forEach((item) => {
     
        
        setFormData((prevState) => ({ ...prevState, [item['key']]: item['value'] }));
      
    });
  }
  if (userCommonAssets.length > 0) {
    userCommonAssets.forEach((item) => {
     
      if ([item['key']] != "field_q_a") {
        setFormData((prevState) => ({ ...prevState, [item['key']]: item['value'] }));
      }
    });
  }
  if (picture) {
    setPreviewImageUrl(picture);
    setShowDeletePictureCheckbox(true);
  } else {
    setPreviewImageUrl("/basic/web/images/notavailable.jpg");
  }
 
}, [picture]);
const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  if (name === 'pictureDelete') {

    //alert("hai");
    setFormData(prev => ({ ...prev, pictureDelete: checked }));
     setFormData(prev => ({ ...prev, picture: null }));
         
    if (checked) {
      setPreviewImageUrl("/basic/web/images/notavailable.jpg");
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  } else if (name.startsWith('social.')) {
    const key = name.split('.')[1];
    setFormData(prev => ({
      ...prev,
      social: { ...prev.social, [key]: value }
    }));
  } else if (type === 'checkbox') {
    if(name == "field_show_on_frontend_ambassado") {
        setFormData(prev => ({ 
                ...prev, 
                [name]: checked ? 1 : 0 
            }));
    } else {
    setFormData(prev => ({ ...prev, [name]: checked }));
    }
  } 
  else if (name === 'field_sports_focus') {
  }
  else {
    setFormData(prev => ({ ...prev, [name]: value }));
  }
};


const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
  const maxSize = 2 * 1024 * 1024; // 2MB

  const errors = [];

  if (!validTypes.includes(file.type)) {
    errors.push('Only JPG, PNG, or GIF images are allowed.');
  }

  if (file.size > maxSize) {
    errors.push('Image must be under 2MB.');
  }

  const reader = new FileReader();
  const img = new Image();

  reader.onload = function (e) {
    img.src = e.target.result;
  };

  img.onload = function () {
    if (
      img.width < 100 || img.height < 100 ||
      img.width > 1000 || img.height > 1000
    ) {
      errors.push('Image dimensions must be between 100x100 and 1000x1000 pixels.');
    }

    if (errors.length > 0) {
  alert(errors.join('\n'));

  setFormErrors(prev => ({ ...prev, picture: null })); //  clear errors first
  setFormData(prev => ({ ...prev, picture: null })); //  remove picture
  setPreviewImageUrl("/basic/web/images/notavailable.jpg"); // reset preview
  if (fileInputRef.current) fileInputRef.current.value = ""; // clear input

  return;
}


    // Valid image
    setFormData(prev => ({ ...prev, picture: file, pictureDelete: false }));
    setPreviewImageUrl(URL.createObjectURL(file));
    setFormErrors(prev => ({ ...prev, picture: null }));
  };

  reader.readAsDataURL(file);
};



  const handleSportsFocusChange = (e) => {
    const selectedValues = Array.from(e.target.selectedOptions, opt => opt.value);
    setFormData(prev => ({ ...prev, field_sports_focus: selectedValues }));
  };

   const validateForm = () => {
  const errors = {};

  if (formErrors.picture && formData.picture !== null) {
    errors.picture = formErrors.picture;
  }
    //ambassador slug
        //      if (data.field_ambassador_slug) {
        //     if (!data.field_ambassador_slug?.trim()) {      
        //     errors.push("Ambassador Slug field is required.");
        //         newFieldErrors.field_ambassador_slug = true;
        //     }
        //  }

 const { social } = formData;

  if (social.field_linkedin_url && social.field_linkedin_url.trim() !== '') {
    const linkedinurl = social.field_linkedin_url.toLowerCase();
    if (!linkedinurl.includes("linkedin.com/")) {
    errors.social = {
  ...errors.social,
  field_linkedin_url: 'Please enter a valid LinkedIn URL',
};

    }
  }

  return errors;
};

const handleSubmit = async (e) => {
  e.preventDefault();

  const errors = validateForm();
  setFormErrors(errors);
//  console.log("Submitting form data:", formData);

  // If picture error exists, show it directly
  if (errors.picture) {
    alert(errors.picture);
    return;
  }
    // Show LinkedIn error if it exists
  if (errors.social?.field_linkedin_url) {
    alert(errors.social.field_linkedin_url);
    return;
  }

  // If there are other errors (optional: expand later if needed)
  if (Object.keys(errors).length > 0) {
    alert("Please fix the form errors before submitting.");
    return;
  }

setButtonText('Saving...');
const finalBio = cleanHtmlOutput(formData.field_biography);
const finalEducation = cleanHtmlOutput(formData.field_education);
const finalQA = cleanHtmlOutput(formData.field_q_a);
const finalContact = cleanHtmlOutput(formData.field_how_to_contact_client);

const updatedFormData = {
  ...formData,
  field_biography: finalBio,
  field_education: finalEducation,
  field_q_a: finalQA,
  field_how_to_contact_client: finalContact,
};

const postData = new FormData();
      postData.append('file', formData.picture);
      postData.append('formData', JSON.stringify(updatedFormData));
      const response = await fetch(app_url+'editprofile/putuserambassadoreditdetails', {
      method: 'POST',
      body: postData,
     
      });
      const data = await response.json();
      if(data.data.msg === "Success") {
        // setSuccess(data.data.result);
        navigate(`/user/${uid}/ambassador`, {
            state: {
            result: data.data.result,
            }
        });
        setButtonText('Save changes');
        setShowDeletePictureCheckbox(true); 
        window.scrollTo(0, 0);

          if (formData.pictureDelete) {
    setShowDeletePictureCheckbox(false);
    setPreviewImageUrl("/basic/web/images/notavailable.jpg"); // reset preview if needed
  }
      }  else {
            setErrors(data.data.result);
            setSuccess({});
            setButtonText('Save changes');
            window.scrollTo(0, 0);
        }

  };

 const handleCancel = (e) => {
     e.preventDefault();
   const confirmed = window.confirm('Are you sure?');

    if (confirmed) {
      // User clicked "OK", proceed with the action
     window.location.href = "/user/"+uid;
      // Add your deletion logic here
    } else {
      // User clicked "Cancel"
      
    }
    
  };


  return (
       
        <div 
        // className="edit-ambassador-container"
         className="Applicantedit-profile-container"
        >
           {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || 
            userLoggedInRoles.includes(configData.ROLE_SAADMIN) || 
            userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE) ? (
                  <>
          {success.length > 0 && (
            <>
            {success.map((item, index) => {
                return <>
                <br/><div className="set-message-done">
                <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {item}
                </div></>
          
            })}  
            </>
        )}    
          <form onSubmit={handleSubmit} className="edit-ambassador-block">

            {errors.length > 0 && (
                <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`,"padding":"15px 10px 19px 50px"}}>
                  {errors.map((item, index) => (
                    <div key={index}>{item}</div>
                  ))} 
                </div>
            )}

             <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("ambassadordetails")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Ambassador Details</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.ambassadordetails ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.ambassadordetails && (
                                <>
                                     {/* Picture */}
            <div className="ambassador-image-container field-row">
              <span className="label"><label>Picture</label></span>
             
              {/* {picture ? (
                //  <div className="form-item">
                //   <img  src={picture} alt="Ambassador"/><br/>
                <div className="form-item">
  <img src={previewImageUrl} alt="Ambassador" /><br />
                <input
                  type="checkbox"
                  id="edit-picture-delete"
                  name="pictureDelete"
                  checked={formData.pictureDelete}
                  onChange={handleChange}
                />
                <label htmlFor="edit-picture-delete" className="option">Delete picture</label>
                  <div className="description">
                                            Check this box to delete your current picture.
                                            </div>
              </div>
              ) : (
              <img  src={previewImageUrl} alt="Ambassador"/>
              )} */}
<div className="value">
<div className="form-item">
  <img src={previewImageUrl} alt="Ambassador" /><br />

  {showDeletePictureCheckbox && (
    <>
      <input
        type="checkbox"
        id="edit-picture-delete"
        name="pictureDelete"
        checked={formData.pictureDelete}
        onChange={handleChange}
      />
      <label htmlFor="edit-picture-delete" className="option" style={{color: "#555"}}>Delete picture</label>
      <div className="description">
        Check this box to delete your current picture.
      </div>
    </>
  )}
</div>

              <div className="form-item">
                <span className="label"><label htmlFor="edit-picture-upload">Upload picture</label></span>
                <input
                  type="file"
                  ref={fileInputRef}
                  id="edit-picture-upload"
                  accept="image/*"
                  onChange={handleFileChange}
                />
                {/* {formErrors.picture && <div className="error">{formErrors.picture}</div>} */}
              </div>
                <div className="description form-item" style={{paddingTop: "0px"}}>
                    Your virtual face or picture. Pictures larger than 1024x1024 pixels will be scaled down. 
                    Image size must be a minimum of 100×100 px or a maximum of 1000×1000 px
                </div></div>
            </div>

                {/* Sports Focus */}
            <div className="form-item field-row">
              <span className="label"><label>Sports Focus</label></span>
              <select multiple value={formData.field_sports_focus} onChange={handleSportsFocusChange}>
                {sportsOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
                  <div className="field-show-on-frontend-ambassador field-row" id="edit-field-show-on-frontend-ambassado">
        <div className="">
          <input
            type="checkbox"
            id="edit-field-show-on-frontend-ambassado-und"
            name="field_show_on_frontend_ambassado"
           checked={formData.field_show_on_frontend_ambassado === 1}
           // defaultChecked={formData.field_show_on_frontend_ambassado === "1" ? "true":"false"}
            onChange={handleChange}
            className="form-checkbox"
          />
          <label className="option" htmlFor="edit-field-show-on-frontend-ambassado-und" style={{color: "#555", fontWeight: "bold"}}>
            Show on Frontend Global Ambassador
          </label>
        </div>
      </div>
      {userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) &&
      <div className='form-item field-row'>
        <span className="label"><label htmlFor="edit-field-ambassador-slug">Ambassador Slug</label></span>
        <span className="value"><input className="" type="text" id="edit-field-ambassador-slug" name="field_ambassador_slug" value={formData.field_ambassador_slug} maxlength="255" onChange={handleChange}/></span>
      </div>}

      </>)}</fieldset>
           

            {/* <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("ambassadorbio")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Biography</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.ambassadorbio ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.ambassadorbio && (
                                <>
            <div className="form-item field-row">
              <span className="label mentor-bio-label"><label>Biography</label></span>
              <span className="value">{editorMode.biography ? (
                <Editor value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} />
              ) : (
                <>
                <textarea className="edit-ambassador-textarea" value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} />
                <div
                    className="grippie" 
                    style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                >
                </div>
                </>
              )}
              {formErrors.field_biography && <div className="error">{formErrors.field_biography}</div>}
              <a onClick={() => toggleEditor('biography')}>Switch to {editorMode.biography ? 'Plain' : 'Rich'} Editor</a></span>
            </div>
                                </>)}</fieldset> */}
{/* Biography */}
<div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ambassadorbio"] ? "open" : ""}`}>
  <div class="app-aspect-content" onClick={() => handleToggle("ambassadorbio")}>
      <div class="aspect-info">
          <span class="view-user-profile-section-heading"><strong>Biography</strong></span>
      </div>
  </div>
  {toggles.ambassadorbio && (     
  <div className="form-item field-row view-user-profile-section-body-container">
    <span className="label"><label htmlFor="edit-scout-bio">Biography</label></span>
    <span className="value"><div className="form-textarea-wrapper">
        <div>
          {editorMode.biography ? (
            <Editor value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} />
          ) : (
            <>
            <textarea className="edit-ambassador-textarea" value={formData.field_biography} onChange={e => onEditorChange('field_biography', e.target.value)} />
            <div
                className="grippie" 
                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
            >
            </div>
            </>
          )}
          {formErrors.field_biography && <div className="error">{formErrors.field_biography}</div>}
          <a onClick={() => toggleEditor('biography')}>Switch to {editorMode.biography ? 'Plain' : 'Rich'} Editor</a>
        </div>
        </div>
    </span>
  </div>)}
</div>  

                              {/* <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("ambassadoreducation")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Education</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.ambassadoreducation ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.ambassadoreducation && (
                                <>
                                
                                <div className="form-item field-row">
                                <span className="label mentor-bio-label"><label>Education</label></span>
                                <span className="value">{editorMode.education ? (
                                    <Editor value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                                ) : (
                                    <>
                                    <textarea className="edit-ambassador-textarea" value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
                                    <div
                                        className="grippie" 
                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                    >
                                    </div>
                                    </>
                                )}
                                {formErrors.education && <div className="error">{formErrors.education}</div>}
                                <a onClick={() => toggleEditor('education')}>Switch to {editorMode.education ? 'Plain' : 'Rich'} Editor</a>
                                </span>
                                </div>
                                </>)}</fieldset> */}

{/* Education */}
<div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ambassadoreducation"] ? "open" : ""}`}>
  <div class="app-aspect-content" onClick={() => handleToggle("ambassadoreducation")}>
      <div class="aspect-info">
          <span class="view-user-profile-section-heading"><strong>Education</strong></span>
      </div>
  </div>
  {toggles.ambassadoreducation && (     
  <div className="form-item field-row view-user-profile-section-body-container">
    <span className="label"><label htmlFor="edit-scout-bio">Education</label></span>
    <span className="value"><div className="form-textarea-wrapper">
        <div>
          {editorMode.education ? (
            <Editor value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
          ) : (
            <>
            <textarea className="edit-ambassador-textarea" value={formData.field_education} onChange={e => onEditorChange('field_education', e.target.value)} />
            <div
                className="grippie" 
                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
            >
            </div>
            </>
          )}
          {formErrors.education && <div className="error">{formErrors.education}</div>}
          <a onClick={() => toggleEditor('education')}>Switch to {editorMode.education ? 'Plain' : 'Rich'} Editor</a>
        </div>
        </div>
    </span>
  </div>)}
</div>  

{/* Q&A   */}
<div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ambassadorqa"] ? "open" : ""}`}>
  <div class="app-aspect-content" onClick={() => handleToggle("ambassadorqa")}>
      <div class="aspect-info">
          <span class="view-user-profile-section-heading"><strong>Q&A</strong></span>
      </div>
  </div>
  {toggles.ambassadorqa && (     
  <div className="form-item field-row view-user-profile-section-body-container">
    <span className="label"><label htmlFor="edit-scout-bio">Q&A</label></span>
    <span className="value"><div className="form-textarea-wrapper">
        <div>
          {editorMode.qa ? (
            <Editor value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
          ) : (
            <>
            <textarea className="edit-ambassador-textarea" value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
            <div
                className="grippie" 
                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
            >
            </div>
            </>
          )}
          {formErrors.field_q_a && <div className="error">{formErrors.field_q_a}</div>}
          <a onClick={() => toggleEditor('qa')}>Switch to {editorMode.qa ? 'Plain' : 'Rich'} Editor</a>                                  
        </div>
        </div>
    </span>
  </div>)}
</div>  
                          {/* <fieldset className='admin-edit-profile-toggle'>
                            <span onClick={() => handleToggle("ambassadorqa")} style={{color:"#0074bd", cursor:"pointer"}}> 
                                <div className='section-header'>
                                <span className="toggle-titles">Q & A</span>                                
                                <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.ambassadorqa ? '▼ ' : '▶ '}</span>
                                </div>
                            </span>
                            {toggles.ambassadorqa && (
                                <>
                            <div className="form-item field-row">
                            <span className="label mentor-bio"><label>Q&A</label></span>
                            <span className="value">{editorMode.qa ? (
                                <Editor value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
                            ) : (
                                <>
                                <textarea className="edit-ambassador-textarea" value={formData.field_q_a} onChange={e => onEditorChange('field_q_a', e.target.value)} />
                                <div
                                    className="grippie" 
                                    style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                >
                                </div>
                                </>
                            )}
                            {formErrors.field_q_a && <div className="error">{formErrors.field_q_a}</div>}
                            <a onClick={() => toggleEditor('qa')}>Switch to {editorMode.qa ? 'Plain' : 'Rich'} Editor</a></span>
                            </div>
                                </>)}</fieldset> */}

<div className={`view-user-profile-section-header Applicantedit-profile-container ${toggles["ambassadorhowtocontact"] ? "open" : ""}`}>
  <div class="app-aspect-content" onClick={() => handleToggle("ambassadorhowtocontact")}>
      <div class="aspect-info">
          <span class="view-user-profile-section-heading"><strong>How to Contact</strong></span>
      </div>
  </div>
  {toggles.ambassadorhowtocontact && (     
  <div className="form-item field-row view-user-profile-section-body-container">
    <span className="label"><label htmlFor="edit-scout-bio">How to Contact</label></span>
    <span className="value"><div className="form-textarea-wrapper">
        <div>
          {editorMode.contact ? (
          <Editor value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} />
        ) : (
          <>
          <textarea className="edit-ambassador-textarea" value={formData.field_how_to_contact_client} onChange={e => onEditorChange('field_how_to_contact_client', e.target.value)} />
          <div
              className="grippie" 
              style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
          >
          </div>
          </>
        )}
        {formErrors.contact && <div className="error">{formErrors.contact}</div>}
        <a onClick={() => toggleEditor('contact')}>Switch to {editorMode.contact ? 'Plain' : 'Rich'} Editor</a>                                    
        </div>
        </div>
    </span>
  </div>)}
</div>   

            {/* Social Media Fields */}
            <fieldset className='admin-edit-profile-toggle'>
              <span onClick={() => handleToggle("ambassadorsocialmedia")} style={{color:"#0074bd", cursor:"pointer"}}> 
                  <div className='section-header'>
                  <span className="toggle-titles">Social Media</span>                                
                  <span style={{ fontSize: '10px'}} className='toggle-icon'>{toggles.ambassadorsocialmedia ? '▼ ' : '▶ '}</span>
                  </div>
              </span>
              {toggles.ambassadorsocialmedia && (
                <>
                  <div className="fieldset-wrapper">
                      {[
                      ['field_instagram_url', 'Instagram URL'],
                        ['field_instagram_handle', 'Instagram Handle'],
                      ['field_facebook_url', 'Facebook URL'],
                      ['field_facebook_handle', 'Facebook Handle'],
                      ['field_twitter_url', 'Twitter URL'],
                      ['field_user_youtube_url', 'YouTube URL'],
                      ['field_linkedin_url', 'LinkedIn URL'],
                      ['field_linkedin_handle','LinkedInHandle']
                      ].map(([key, label]) => (
                        <div className="form-item field-row" key={key}>
                          <span className="label"><label>{label}</label></span>
                          {key === 'field_linkedin_url' ? (
                            <span className="value">
                            <textarea
                              className="edit-ambassador-textarea"
                              name={`social.${key}`}
                              value={formData.social[key]}
                              onChange={handleChange}
                              rows={4}
                            />
                            <div
                                className="grippie" 
                                style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                            >
                            </div>
                            </span>
                          ) : (
                            <span className="value"><input
                              type="text"
                              className="text-full form-text"
                              name={`social.${key}`}
                              value={formData.social[key]}
                              onChange={handleChange}
                            /></span>
                          )}
                        </div>
                      ))}
                  </div>
                </>
              )}

            </fieldset>                    

            {/* Submit */}
                <div className="form-actions">
                  <input type="submit" value={buttonText} className=" form-submit" style={{background: "#091c59"}} />
                  <input type="submit" value="Cancel account" className="edit-ambassador-form-cancel" onClick={handleCancel}
                      style={{ background: `#999 url("/basic/web/images/overlay.png") repeat-x` }} 
                  />
                </div>

          </form>
          </>
              ) : (
       <><p>You are not authorized</p></>   
        )}
        </div>
     
  );
};

export default EditAmbassadorProfile;